import React from 'react';
import { Flex, Text, Box } from '@chakra-ui/react';


const DeliveryItem = ({ b_nm, status, orderCount }) => {
  const statusColor = status === '배송완료' ? 'blue.500' : '#E9673D';

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
    >
      <Box>
        <Text mb={3}>{b_nm}</Text>
        <Flex alignItems="center" gap={2}>
          <Text color={statusColor} fontSize="md">{status}</Text>
          {/* 한 배송묶음에 주문이 여러 건일 수 있어 건수를 함께 보여준다 */}
          {orderCount > 1 && (
            <Text color="gray.500" fontSize="sm">주문 {orderCount}건</Text>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};

export default DeliveryItem;